// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"08265e42","395":"84b04a90","423":"da8ad75d","438":"6ac2287a","457":"ac1e1e79","580":"3de1314d","652":"17cdc1ad","681":"00712d7d","770":"a2231137"}[chunkId] + ".js";
};